(function() { module.exports = window["wp"]["editSite"]; }());